var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.5V12.5C23.5 10.6435 22.7625 8.86301 21.4497 7.55025C20.137 6.2375 18.3565 5.5 16.5 5.5C14.6435 5.5 12.863 6.2375 11.5503 7.55025C10.2375 8.86301 9.5 10.6435 9.5 12.5V15.5C9.5 18.8 6.5 19.6 6.5 21.5C6.5 23.2 10.4 24.5 16.5 24.5C22.6 24.5 26.5 23.2 26.5 21.5C26.5 19.6 23.5 18.8 23.5 15.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 26.5004C15.4885 26.5004 14.5385 26.4664 13.6445 26.4004C13.8351 27.0084 14.2148 27.5396 14.7283 27.9168C15.2419 28.294 15.8624 28.4974 16.4995 28.4974C17.1367 28.4974 17.7572 28.294 18.2707 27.9168C18.7842 27.5396 19.1639 27.0084 19.3545 26.4004C18.4605 26.4664 17.5105 26.5004 16.4995 26.5004Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/ALERT.d1f4d9379131f695c7ccfdae25ccc30b.svg";
export { ForwardRef as ReactComponent };